import './AlertMessage.scss'
import {useEffect, useRef, useState} from "react";


export default function AlertMessage(props) {
    const refAlert = useRef()

    const [classAlert, setClassAlert] = useState('alert_message')

    useEffect(() => {
        if (props.show === 'true') {
            setClassAlert('alert_message show')
            setTimeout(() => {
                setClassAlert('alert_message')
            }, 3000)
        }
    }, [props.show])

    return (
        <div ref={refAlert} className={classAlert} {...props}>
            <div className="image_alert_message"></div>
            <p>{props.text}</p>
        </div>
    )
}